import moment from 'moment';
const dateTransform = {

    /**
     * 民國 轉 西元
     * 1101230 or 110/12/30 -> ["2021","12","30"]
     * 
     * @param {String} date
     * @returns {[string, string, string]}
     */
    rocToCe: (date) => {
        date = date.replace(/\//g, '');
        date = date.replace(/-/g, '');
        date = Number(date);
        date = date.toString();

        let year = date.slice(0, -4);
        let month = date.slice(-4, -2);
        let day = date.slice(-2);
        return [String(year * 1 + 1911), month, day];
    },

    /**
     * 西元 轉 民國
     * 20211230 or 2021/12/30 -> ["110","12","30"]
     * 
     * @param {String} date
     * @returns {[string, string, string]}
     */
    ceToRoc: (date) => {
        date = date.toString();
        date = date.replace(/\//g, '');
        date = date.replace(/-/g, '');

        let year = date.slice(0, -4);
        let month = date.slice(-4, -2);
        let day = date.slice(-2);

        return [String(year * 1 - 1911), month, day];
    },

    /**
     * 民國 array 轉 民國字串
     * ["110","12","30"] -> 民國110年12月30日
     * 
     * @param {Array} date
     * @returns {String}
     */
    toRocString: (date) => {
        return '民國' + date[0] + '年' + date[1] + '月' + date[2] + '日';
    },

    /**
     * 西元年日期 轉 民國日期
     * 2021-12-30T00:00:00 -> 民國110年12月30日
     * 
     * @param {String} date 
     * @returns {String} 
     */
    standardToRocString: (date) => {
        date = moment(date).format('YYYYMMDD');
        date = dateTransform.ceToRoc(date);
        return dateTransform.toRocString(date);
    }
};

export default dateTransform;
